import { FaImage } from 'react-icons/fa';

/**
 * Reusable NoImagePlaceholder component
 * Displays a professional placeholder when an image is missing
 * 
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.width - Width of the placeholder (default: '100%')
 * @param {string} props.height - Height of the placeholder (default: '100%')
 * @param {string} props.message - Custom message to display (default: 'Image not available')
 * @param {string} props.variant - Style variant: 'default', 'gradient', 'minimal' (default: 'gradient')
 */
const NoImagePlaceholder = ({ 
  className = '', 
  width = '100%', 
  height = '100%',
  message = 'Image not available',
  variant = 'gradient'
}) => {
  const baseStyles = {
    width,
    height,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden'
  };

  const variantStyles = {
    gradient: {
      background: 'linear-gradient(135deg, rgba(81, 67, 217, 0.08) 0%, rgba(81, 67, 217, 0.15) 100%)',
      border: '1px dashed rgba(81, 67, 217, 0.2)',
      color: 'rgba(81, 67, 217, 0.6)'
    },
    default: {
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      color: '#6c757d'
    },
    minimal: {
      background: 'rgba(0, 0, 0, 0.02)',
      border: '1px solid rgba(0, 0, 0, 0.05)',
      color: '#adb5bd'
    }
  };

  const currentVariant = variantStyles[variant] || variantStyles.gradient;

  return (
    <div 
      className={`no-image-placeholder ${className}`}
      style={{
        ...baseStyles,
        ...currentVariant
      }}
    >
      <div className="no-image-placeholder__icon">
        <FaImage size={32} />
      </div>
      <div className="no-image-placeholder__message">
        {message}
      </div>
    </div>
  );
};

export default NoImagePlaceholder;

